// Redux types for layer templates
export const LAYER_TEMPLATE_FETCH_REQUEST = "LAYER_TEMPLATE_FETCH_REQUEST";
export const LAYER_TEMPLATE_FETCH_SUCCESS = "LAYER_TEMPLATE_FETCH_SUCCESS";
export const LAYER_TEMPLATE_FETCH_FAILURE = "LAYER_TEMPLATE_FETCH_FAILURE";

export const LAYER_TEMPLATE_CREATE_SUCCESS = "LAYER_TEMPLATE_CREATE_SUCCESS";
export const LAYER_TEMPLATE_UPDATE_SUCCESS = "LAYER_TEMPLATE_UPDATE_SUCCESS";
export const LAYER_TEMPLATE_DELETE_SUCCESS = "LAYER_TEMPLATE_DELETE_SUCCESS";
